import { takeLatest, put, call } from 'redux-saga/effects';
import BranchWiseFetchDetailsTypes from './BranchWiseFetchDetails.types';
import { fetchBranchWiseAttendanceData } from './BranchWiseFetchDetails.services';
import { branchWiseFetchSuccess, branchWiseFetchFailure } from './BranchWiseFetchDetails.action';
import { encryptData } from '../_common/enode-decode';
import AlertManager from '../../utils/alertManager';

export function* fetchBranchWiseDataSaga(payload: any) {
	try {
		const key = 'fetchBranchWiseDataKey';
		const encryptedData = encryptData(payload.payload, key);
		// @ts-ignore
		const responseData = yield call(fetchBranchWiseAttendanceData as any, encryptedData);
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else {
			if (responseData.data.status === 'error') {
				if (process.env.NODE_ENV === 'development') console.log('Received failure response');
				yield put(branchWiseFetchFailure(responseData.data));
			} else {
				if (process.env.NODE_ENV === 'development') console.log('Received success response');
				yield put(branchWiseFetchSuccess(responseData.data));
			}
		}
	} catch (error: any) {
		if (process.env.NODE_ENV === 'development') console.error('Error in fetchBranchWiseData:', error);
		yield put(branchWiseFetchFailure(error?.response?.data?.message || 'An error occurred'));
	}
}

export function* onBranchWiseFetchStart(): Generator<any, void, any> {
	yield takeLatest(
		BranchWiseFetchDetailsTypes.BRANCH_WISE_FETCH_START as any,
		fetchBranchWiseDataSaga,
	);
}

export function* branchWiseFetchDetailsSaga(): Generator<any, void, any> {
	yield call(onBranchWiseFetchStart);
}
